import { useQuery } from '@tanstack/react-query';
import _keyBy from 'lodash/keyBy';

import { QueryKey } from ':cloud/queries/types';
import { APIClient } from ':cloud/state/Api';
import { INetworkVersion, ProtocolKey } from ':cloud/types/ts_types';

async function fetchAllVersions(protocol: ProtocolKey): Promise<INetworkVersion[]> {
  const path = `/v1/networks/${protocol}/versions`;
  const { data } = await APIClient.get<INetworkVersion[]>(path);
  return data;
}

// Returns list of upgradable versions for this workflow
export function useGetAvailableVersions(key: ProtocolKey): {
  isLoading: boolean;
  versions: string[];
} {
  const { isLoading, data } = useQuery({
    queryKey: [QueryKey.workflows, 'versions', key],
    queryFn: async () => fetchAllVersions(key),
    meta: { retry: 1 },
    staleTime: Infinity,
    enabled: !!key,
  });

  const versions = data ? Object.keys(_keyBy(data, 'version')) : [];
  return { isLoading, versions };
}
